import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';

import { LocalizationContext, UserContext } from '../../../../AppContext';
import CustomToolbar from '../../../../components/CustomToolbar';
import ColumnDefinition from './CitiesColumnDefinition';
import RowsMapper from './CitiesRowsMapper';
import localization from './Cities.local';

export default function Cities({
  cities,
  citysettingdefinitions,
  citysettings,
  district,
  districts,
  elections,
  officials,
  parties,
}) {
  const local = localization[useContext(LocalizationContext)];
  const user = useContext(UserContext);
  const [rows, setRows] = useState();
  const [columns, setColumns] = useState();
  const navigate = useNavigate();

  useEffect(() => setColumns(ColumnDefinition(local, citysettingdefinitions, district, user)), [citysettingdefinitions, district, user]);
  useEffect(() => setRows(RowsMapper(
    local,
    cities,
    citysettingdefinitions,
    citysettings,
    districts,
    district,
    elections,
    officials,
    parties,
    user,
  )), [cities, citysettings, districts, district, elections, officials, parties, user]);

  return (
    <Paper sx={{ height: '100%' }}>
      { columns && rows && (
      <DataGrid
        sx={{ height: '100%' }}
        rows={rows}
        columns={columns}
        components={{ Toolbar: CustomToolbar }}
        onRowClick={({ row }) => navigate(`/${row.districtid}/${row.id}`)}
      />
      )}
    </Paper>
  );
}

Cities.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.shape({})),
  citysettingdefinitions: PropTypes.arrayOf(PropTypes.shape({})),
  citysettings: PropTypes.arrayOf(PropTypes.shape({})),
  districts: PropTypes.arrayOf(PropTypes.shape({})),
  district: PropTypes.shape({
    id: PropTypes.number,
  }),
  elections: PropTypes.arrayOf(PropTypes.shape({})),
  officials: PropTypes.arrayOf(PropTypes.shape({})),
  parties: PropTypes.arrayOf(PropTypes.shape({})),
};

Cities.defaultProps = {
  cities: undefined,
  citysettingdefinitions: undefined,
  citysettings: undefined,
  districts: undefined,
  district: undefined,
  elections: undefined,
  officials: undefined,
  parties: undefined,
};
